// This component has been added ad-hoc by coaching-fe team: https://private.hubteam.com/janus/groups/hs-coaching-fe
// For any questions/concerns, please use Slack channel: #coaching-fe

import BooleanQuickFilter from '../BooleanQuickFilter';
import TranscriptSettingPlaceholder from './TranscriptSettingPlaceholder';
import TranscriptUpgradePlaceholder from './TranscriptUpgradePlaceholder';
import { useTranscriptData } from './hooks/useTranscriptData';
import { hasTranscriptionFeature as hasTranscriptionFeatureFunction } from 'customer-data-filters-ui/permissions/scopes';
import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../../../state/SegmentationFiltersInstanceContext';
import { jsx as _jsx } from "react/jsx-runtime";
const TranscriptQuickFilter = filterProps => {
  const {
    hasScope
  } = useContext(SegmentationFiltersInstanceContext);
  const hasTranscriptionFeature = hasTranscriptionFeatureFunction(hasScope);
  const {
    hasTranscriptSettingEnabled,
    loading,
    error
  } = useTranscriptData(hasTranscriptionFeature);
  if (!hasTranscriptionFeature) {
    return /*#__PURE__*/_jsx(TranscriptUpgradePlaceholder, {});
  }
  if (loading || error) {
    return null;
  }
  if (hasTranscriptSettingEnabled) {
    return /*#__PURE__*/_jsx(BooleanQuickFilter, Object.assign({}, filterProps));
  }
  return /*#__PURE__*/_jsx(TranscriptSettingPlaceholder, {});
};
export default TranscriptQuickFilter;